import { autoserializeAs } from 'cerialize';

export class SiteUserSettings {
  @autoserializeAs('advanced_features_email_notifications')
  advancedFeaturesEmailNotifications!: boolean;
}
